import { getApiUrl } from '../../config/environment';
import { getAuthHeaders } from './authUtils';

/** Backend returns 400 if limit > 100 (e.g. "Limit must be between 1 and 100"). */
export const ADMIN_LIST_PAGE_LIMIT = 100;

const MAX_ORDER_PAGES = 200;

/**
 * Loads admin orders in pages of {@link ADMIN_LIST_PAGE_LIMIT} until a short page or empty.
 * @throws {Error} on non-OK HTTP or explicit API failure
 */
export async function fetchAllAdminOrdersForAgg() {
  const all = [];
  for (let page = 1; page <= MAX_ORDER_PAGES; page += 1) {
    const res = await fetch(
      getApiUrl(`/admin/orders?limit=${ADMIN_LIST_PAGE_LIMIT}&page=${page}`),
      { headers: getAuthHeaders() }
    );
    if (!res.ok) {
      throw new Error(`Orders request failed (${res.status})`);
    }
    const data = await res.json();
    if (data.success === false) {
      throw new Error(data.message || data.error || 'Failed to load orders');
    }
    const list = data.data || data.orders || [];
    const arr = Array.isArray(list) ? list : [];
    all.push(...arr);
    if (arr.length < ADMIN_LIST_PAGE_LIMIT) break;
  }
  return all;
}
